var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-section",class:{ 'theme-dark': _vm.dark }},[(_vm.title)?_c('p',{staticClass:"form-section-title",class:{
      'blue': _vm.blueTitle,
      'is-uppercase': _vm.uppercase,
      'has-line': _vm.hasLine
    }},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.hasLine)?_c('hr',{staticClass:"form-section-line"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }